import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Contact.css';
import ParallaxBasic from '../../components/page/parallaxBasic/ParallaxBasic.jsx';
import HeroImage from './hero-contact.png';
import Form from "../../components/page/form/Form";
import Footer from '../../components/global/footer/Footer.jsx';


// let Scroller = Scroll.scroller;

/**
 * @class Contact
 * @namespace Architect\React\Views
 * @author Mike Rudling <mrudling@wearearchitect.com>
 */
export default class Contact extends Component {

    /**
     * Default props
     *
     * @type {{scrollOptions: {duration: number, delay: number, smooth: boolean}, ctaText: string, gridBlocksData: *[]}}
     */
    static defaultProps = {
        heroImage: HeroImage,
        parallaxTitle: 'Fruit Bar Fan Mail',
        parallaxSubTitle: 'Thank you for visiting Solero.com. We’d love to hear from you! Leave us a message and we’ll get back to you soon.',
        scrollOptions: {
            duration: 1500,
            delay: 100,
            smooth: true
        },
        parallaxBasicClassNames: classNames('ParallaxBasic', 'Parallax__group', 'ParallaxBasic--short'),
    };

    /**
     * Prop types
     *
     * @type {{parallaxTitle, parallaxSubTitle, ctaText: shim,  scrollOptions: shim, ParallaxBasicClassNames: shim}}
     */
    static propTypes = {
        heroImage: PropTypes.string,
        ctaText: PropTypes.string,
        scrollOptions: PropTypes.object,
        parallaxBasicClassNames: PropTypes.string,
    };

    /**
     * Render
     *
     * @returns {XML}
     */
    render() {
        const {heroImage, parallaxTitle, parallaxSubTitle, parallaxBasicClassNames, setHeaderClassNames} = this.props;

        return (

            <main className="Contact Parallax">

                <ParallaxBasic background={heroImage}
                               parallaxBasicClassNames={parallaxBasicClassNames}
                               parallaxTitle={parallaxTitle}
                               parallaxSubTitle={parallaxSubTitle}
                               setHeaderClassNames={setHeaderClassNames}/>

                <Form/>

                <Footer/>

            </main>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/contact/Contact.jsx